/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-lines */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-console */
/* eslint-disable no-magic-numbers */
import React, { useEffect, useMemo, useState, useRef } from 'react'
import Header from '@/components/header/header'
import styles from './fill-information.module.scss'
import { isIOS, isAndroid, validateIDNumber, Storage, debounce } from '@bihu/common-js'
import { Form, Input, Button, CascadePicker, Toast, Popup, Swiper, Modal } from 'antd-mobile'
import type { PickerValue, PickerValueExtend } from 'antd-mobile/es/components/picker'
import cityDate from '@/assets/js/city'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { OptionType } from '@/pages/fill-information/options'
import { TOKEN } from '@/constants/storage'
import {
  creditSesameOptions, // 芝麻分
  applyCreditOptions, // 申请额度
  jobTypeOptions, // 职业类型
  workDurationOptions, // 工作年限
  monthlyProfitOptions, // 月收入
  creditOptions, // 信用情况
  payoffFormOptions, // 工资发放方式
  socialSecurityOptions, // 社保缴纳选项
  accumulationFundOptions, // 公积金选项
  insurancePolicyOptions, // 保险保单选项
  carProductionOptions, // 车产选项
  realEstateOptions // 房产选项
} from './options'
import { getSex, getAge } from '@/utils/utils'
import DetainmentPopup from '@/pages/register/components/detainment-popup/detainment-popup'
import { selectUserInfo } from '@/store/user'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import classNames from 'classnames'
import activityApi from '@/apis/activity'
import FormChooseItem from './components/form-choose-item/form-choose-item' // 选择选项
import ChooseOption from './components/choose-option/choose-option' // 选择选项
import IdentityInfoModal from './components/identity-info-modal/identity-info-modal' // 身份信息弹窗
import MatchAnimate from './components/match-animate/match-animate' // 匹配动画组件
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import indexApi, { FomrSubmitStatusParams } from '@/apis'
import { FqlPhoneModel } from '@/constants/common'
import iconUp from '@/assets/imgs/information/ic-up.png'
import iconRight from '@/assets/imgs/information/ic-right.png'
// 1.首先判断是非支持scrollTo，通过document.documentElement.style上是否有 scroll-behavior 这个属性。
// 2.对element添加scrollTo的方法。在原型对象上添加方法scrollTo
if (!('scrollBehavior' in document.documentElement.style)) {
  const Element = window.HTMLElement || window.Element

  Element.prototype.scrollTo = function() {
    let left = 0
    let top = 0
    if (arguments.length > 1) {
      left = arguments[0]
      top = arguments[1]
    } else {
      left = arguments[0].left
      top = arguments[0].top
    }
    this.scrollLeft = left
    this.scrollTop = top
  }
}

interface Props { }

interface FormDataItem {
  name: string,
  key: string,
  value: string,
  options: OptionType[]
}

// 元信大额，填写资料
const FillInformation: React.FC<Props> = () => {
  // 用户信息
  const userInfo = useAppSelector(selectUserInfo)
  const { channelValue, adChannelCode } = useSelector((state: RootState) => state.channel)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [search] = useSearchParams()
  const [from, setFrom] = useState<string>()
  const [visibleHead, setVisibleHead] = useState(true)

  const [progressPercentage, setProgressPercentage] = useState(55)
  const [estimatedAmount, setEstimatedAmount] = useState(5000)
  const [displayAmount, setDisplayAmount] = useState(5000)

  // 数字滚动动画
  const animateAmount = (startValue: number, endValue: number, duration = 800) => {
    const startTime = Date.now()
    const difference = endValue - startValue

    const animate = () => {
      const elapsed = Date.now() - startTime
      const progress = Math.min(elapsed / duration, 1)

      // 使用缓动函数
      const easeOutQuart = 1 - Math.pow(1 - progress, 4)
      const currentValue = startValue + (difference * easeOutQuart)

      setDisplayAmount(Math.round(currentValue))

      if (progress < 1) {
        requestAnimationFrame(animate)
      }
    }

    animate()
  }

  // 监听estimatedAmount变化，触发动画
  useEffect(() => {
    if (estimatedAmount !== displayAmount) {
      animateAmount(displayAmount, estimatedAmount)
    }
  }, [estimatedAmount])

  // 按钮loading
  const [btnLoading, setBtnLoading] = useState(false)
  const [isFirstSubmit, setIsFirstSubmit] = useState(true)

  const [token, setToken] = useState('')
  useEffect(() => {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    let ua = window.navigator.userAgent.toLowerCase()

    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (/MicroMessenger/i.test(ua) || !visibleHead) {
      document.title = '填写资料'
      setVisibleHead(false)
    }
    const code = search.get('adChannelCode')
    if (code) {
      localStorage.setItem('ad_channel_code', code)
      localStorage.setItem('hostName', '有钱')
    }
  }, [])

  const [userAgentStr, setUserAgentStr] = useState('')
  const [isHuaWeiPhone, setIsHuaWeiPhone] = useState<boolean>(false)
  const [versionType, setVersionType] = useState('')
  const [sexVisible, setSexVisible] = useState<boolean>(false)

  useEffect(() => {
    isHuawei()
  }, [])

  const isHuawei = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    setUserAgentStr(userAgent)
    if (userAgent.indexOf('huawei') !== -1) {
      setIsHuaWeiPhone(true)
      return
    }
    setIsHuaWeiPhone(false)
  }

  const [showWorkDuration, setShowWorkDuration] = useState(Boolean) //工作年限
  const [showMonthlyProfit, setShowMonthlyProfit] = useState(Boolean) //月收入


  // 步骤,当前选择到哪一步
  const [step, setStep] = useState(0)

  const [formDetail, setFormDetail] = useState<any>('')

  useEffect(() => {
    async function checkMobileLogin(reqId: string) {
      const res = await indexApi.checkMobileLogin({ reqId })
      // 如果以前注册过了有钱来，直接登录拿token
      if (res) {
        const loginRes = await activityApi.login({
          upStreamUnionLoginReqId: reqId,
        })
        handleLoginSuccess(loginRes)
      } else {
        // 如果第一次注册有钱来的用户，弹起登录协议弹窗，需用户手动确认再获取token
        formLoginModalRef.current && formLoginModalRef.current.init({ reqId })
      }
    }
    const formTemp = search.get('from')
    const urlToken = search.get('token')
    const reqId = search.get('reqId')

    if (formTemp) {
      setFrom(formTemp)
    }

    let tokenTemp = Storage.get(TOKEN)
    if (reqId) {
      // 处理OPPO联登逻辑
      checkMobileLogin(reqId)
    } else if (urlToken) {
      Storage.set(TOKEN, urlToken)
      setToken(urlToken)
      const url = window.location.href
      const updatedUrl = url.replace(/([?&])token=[^&]+(&|$)/, '$1')
      console.log('updatedUrl', updatedUrl)
      window.history.replaceState(null, 'null', updatedUrl)
    } else if (tokenTemp) {
      setToken(tokenTemp)
    }

    // 与app交互的函数
    window.getToken = function(t: string) {
      Storage.set(TOKEN, t)
      setToken(t)
    }
    try {
      if (isIOS) {
        window.webkit?.messageHandlers?.sendNativeMessage && window.webkit.messageHandlers.sendNativeMessage?.postMessage(JSON.stringify({
          action: 'getToken',
          data: {
            methodName: 'getToken'
          }
        }))
      } else if (isAndroid) {
        window.sendNativeMessage && window.sendNativeMessage?.postMessage(JSON.stringify({
          action: 'getToken',
          data: {
            methodName: 'getToken'
          }
        }))
      }
    } catch (error) {
      // console.log(error)
    }
  }, [])

  useEffect(() => {
    if (formDetail) {
      // 延迟调用 fillData，确保 formItemList 已经初始化
      // setTimeout(() => {
      //   if (formItemList.length > 0) {
      //     fillData(formDetail)
      //   }
      // }, 100)
      fillData(formDetail)
    }
  }, [formDetail, showWorkDuration, showMonthlyProfit])

  useEffect(() => {
    // 查看非必填表单项状态, 判断是否需要隐藏
    async function getFormItemShow() {
      const res: any = await indexApi.getFormItemShow()
      setShowWorkDuration(res.showWorkDuration === 1)
      setShowMonthlyProfit(res.showMonthlyProfit === 1)
    }
    if (token) {
      getFormItemShow()
    }
  }, [token])

  // 获取用户资料
  useEffect(() => {
    async function getApplyStatus() {
      try {
        const res: any = await indexApi.getApplyStatus()
        indexApi.reportUserBehavior(1)
        let devicePlatForm: any = 3
        if (isAndroid) {
          devicePlatForm = 1
        }
        if (isIOS) {
          devicePlatForm = 2
        }
        indexApi.reportPhoneType(devicePlatForm)
        // fillData(res.data)
        setFormDetail(res.data)

        // ToConfirm
        // if (res.data && (res.data?.submitStatus === 1 || res.data?.submitStatus === 10)) {
        if (res.data && res.data?.submitStatus === 1) {
          let submitData: FomrSubmitStatusParams = {
            adChannelCode
          }
          const phoneModel = sessionStorage.getItem('phoneModel')
          if (phoneModel) {
            submitData.phoneModel = phoneModel as FqlPhoneModel
          }
          // 获取上回提交信息
          const submitResult: any = await indexApi.getFomrSubmitStatus(submitData)
          if (submitResult.productName === null) {
            window.location.replace(`/fill-information/success?options=${encodeURIComponent(JSON.stringify({
              isNotFormReq: true,
              rePageShowType: channelValue?.includes('fenqile') && isHuaWeiPhone ? 2 : 0,
              revisit: true
            }))}`)
            return
          }

          if (submitResult.thirdpartyType === 5) {
            window.location.replace(`/fill-information/authorize?options=${encodeURIComponent(JSON.stringify(submitResult))}&adChannelCode=${adChannelCode}&isHuaWeiPhone=${isHuaWeiPhone}&applyLimit=${res.data?.applyLimit}`)
            return
          }
          // 跳转授权页
          let tempOptions = {
            adChannelCode,
            isHuaWeiPhone,
            applyLimit: res.data?.applyLimit,
            workCity: res.data?.workCity,
            rqResult: submitResult
          }
          window.location.replace(`/fill-information/common-authorize?options=${encodeURIComponent(JSON.stringify(tempOptions))}`)
        } else if (res.data && res.data?.submitStatus === 10) {
          let submitData: FomrSubmitStatusParams = {
            adChannelCode
          }
          const phoneModel = sessionStorage.getItem('phoneModel')
          if (phoneModel) {
            submitData.phoneModel = phoneModel as FqlPhoneModel
          }
          // rematchResult: 1-不需要重新匹配 2-重新匹配不到结果 3-重新匹配到结果
          const reMatchResult: any = await indexApi.getFomrSubmitStatus(submitData)
          let tempOptions: any = {}
          // 如果重现匹配并且有结果，跳至动图页
          if (reMatchResult.rematchResult === 3) {
            // 携带授权数据跳转重新匹配结果页
            tempOptions = {
              adChannelCode,
              isHuaWeiPhone,
              applyLimit: res.data?.applyLimit,
              workCity: res.data?.workCity,
              rqResult: reMatchResult
            }
            window.location.replace(`/fill-information/rematch-waiting?options=${encodeURIComponent(JSON.stringify(tempOptions))}`)
            return
          }

          // 否则取上回的结果，跳至下载页
          tempOptions = JSON.parse(JSON.stringify(reMatchResult))
          tempOptions.isNotFormReq = true // 标记为非表单请求方式的跳转
          tempOptions.rePageShowType = channelValue?.includes('fenqile') && isHuaWeiPhone ? 2 : 0
          tempOptions.revisit = true // 标记为再访
          window.location.replace(`/fill-information/success?options=${encodeURIComponent(JSON.stringify(tempOptions))}`)
        }
      } catch (error) {
        console.log('error', error)
      }
    }

    if (token) {
      getApplyStatus()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  // 是否显示弹窗
  const [isShowPopup, setIsShowPopup] = useState<boolean>(false)

  // 返回
  const back = () => {
    navigate(-1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }

  const formLoginModalRef: any = useRef()

  // 真实姓名
  const [realName, setRealName] = useState('')
  // 身份证号
  const [identity, setIdentity] = useState('')
  // 年龄
  const [age, setAge] = useState<any>()
  // 性别
  const [gender, setGender] = useState<any>('')

  // 身份信息弹窗状态
  const [identityInfoModalVisible, setIdentityInfoModalVisible] = useState(false)
  // 匹配动画状态
  const [showMatchAnimation, setShowMatchAnimation] = useState(false)

  const [hasEscalation, setHasEscalation] = useState<boolean>(false) //判断是否上报，上报过的就不再进行上报

  const [formResult, setFormResult] = useState<any>()

  // 弹窗处理函数
  const handleCloseIdentityInfoModal = () => {
    setIdentityInfoModalVisible(false)
  }

  const handleIdentityInfoSubmit = (data: { name: string; idCard: string }) => {
    // 更新姓名和身份证号
    setRealName(data.name)
    setIdentity(data.idCard)
    // 关闭弹窗
    setIdentityInfoModalVisible(false)
    // 可以在这里添加其他处理逻辑，比如提交到服务器等
    // Toast.show('信息提交成功')
    confirm({
      realName: data.name,
      identity: data.idCard
    })
    // confirm()
  }

  const submitFormAfter = (res: any) => {
    // 需要跳转授权页
    if (res && res.productName) {
      if (res.thirdpartyType === 5) {
        window.location.replace(`/fill-information/authorize?options=${encodeURIComponent(JSON.stringify(res))}&adChannelCode=${adChannelCode}&isHuaWeiPhone=${isHuaWeiPhone}&applyLimit=${applyLimit}`)
        return
      }
      // 跳转授权页
      let tempOptions = {
        adChannelCode,
        isHuaWeiPhone,
        applyLimit,
        workCity: cityShow,
        rqResult: res
      }
      window.location.replace(`/fill-information/common-authorize?options=${encodeURIComponent(JSON.stringify(tempOptions))}`)
    } else {
      const query: any = res && res.productName ? res : { rePageShowType: adChannelCode === '9o0w2B' && isHuaWeiPhone ? 2 : 0 }
      window.location.replace(`/fill-information/success?options=${encodeURIComponent(JSON.stringify(query))}`)
    }
  }

  // 处理API请求
  const handleApiRequest = async(params: any) => {
    try {
      const res: any = await indexApi.saveCustomerInfo(params)

      // API请求成功后，隐藏动画并跳转
      setShowMatchAnimation(false)
      const code = localStorage.getItem('ad_channel_code')

      if (channelValue?.includes('bdVid') && !hasEscalation) {
        window._agl && window._agl.push(['track', ['success', { t: 3 }]])
        setHasEscalation(true)
      }
      // 报错表单提交结果
      setFormResult(res)
      submitFormAfter(formResult)

      // window.location.href = `/my-apply-result?options=${encodeURIComponent(JSON.stringify(res))}&adChannelCode=${code}&applyLimit=${params.applyLimit}`
    } catch (error) {
      console.error('API请求失败:', error)
      // 请求失败时也隐藏动画
      setShowMatchAnimation(false)
      Toast.show('提交失败，请重试')
    }
  }

  // 匹配动画完成回调（现在只用于循环播放）
  const handleMatchAnimationComplete = () => {
    // 动画循环播放，不需要特殊处理
    // API请求完成后会自动隐藏动画
  }


  // 表单
  const [form] = Form.useForm()

  // 检验身份证
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const checkIdentity = (_: any, value: string) => {
  //   if (value) {
  //     if (!validateIDNumber(value)) {
  //       Toast.show('身份证号不正确，请重新输入')
  //       return Promise.reject(new Error('身份证号不正确，请重新输入'))
  //     }
  //     return Promise.resolve()
  //   }
  //   Toast.show('请输入身份证号')
  //   return Promise.reject(new Error('请输入身份证号'))
  // }

  // 城市
  const [cityVisible, setCityVisible] = useState(false)
  const [cityValue, setCityValue] = useState<(string | null)[]>([])
  const [cityShow, setCityShow] = useState('')
  const [haveCityData, setHaveCityData] = useState(false)
  const cityConfirm = (value: PickerValue[], extend: PickerValueExtend) => {

    const cityName = extend.items.map(item => item?.label).join()
    setCityShow(cityName)

    const v = value[0]
    if (v === null) {
      return false
    }

    setCityValue(value)
    setHaveCityData(true)

    // 标记城市选择为已完成状态
    markFormItemAsCompleted('workCity', cityName)

    // 城市选择完成后，更新步骤
    if (step < 9) {
      setTimeout(() => {
        setStep(9)
      }, 400)
    }
    form.validateFields(['livingCity'])
  }

  // 居住城市验证
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const checkLivingCity = (_: any, value: string) => {
    if (!cityShow) {
      Toast.show('请选择居住城市')
      return Promise.reject(new Error('请选择居住城市'))
    }
    return Promise.resolve()
  }


  // 是否展开
  const [initIsExpansion, setInitIsExpansion] = useState(true)

  // 芝麻分
  const [sesameCredit, setCreditSesame] = useState('')
  const creditSesameOnChange = (obj: OptionType) => {
    setCreditSesame(obj.value)
    if (obj.value) {
      setTimeout(() => {
        if (step < 9) {
          setStep(9)
        }
      }, 400)
    }
  }

  // 申请额度
  const [applyLimit, setApplyCredit] = useState('')
  const applyCreditOnChange = (obj: OptionType) => {
    setApplyCredit(obj.value)
    if (obj.value) {
      setTimeout(() => {
        if (step < 2) {
          setStep(2)
        }
      }, 400)
    }
  }

  // 职业类型
  const [job, setJob] = useState('')
  const applyJobChange = (obj: OptionType) => {
    setJob(obj.value)
    if (obj.value) {
      setTimeout(() => {
        if (step < 3) {
          setStep(3)
        }
      }, 400)
    }
  }

  // 工作年限
  const [workDuration, setWorkDuration] = useState('')
  const applyWorkDurationOnChange = (obj: OptionType) => {
    setWorkDuration(obj.value)
    scrollDown()
  }

  // 月收入
  const [monthlyProfit, setMonthlyProfit] = useState('')
  const applymonthlyProfitOnChange = (obj: OptionType) => {
    setMonthlyProfit(obj.value)
    scrollDown()
  }

  // 工资发放方式
  const [payoffForm, setPayoffForm] = useState('')
  const applypayoffFormOnChange = (obj: OptionType) => {
    setPayoffForm(obj.value)
    scrollDown()
  }

  // 是否逾期
  const [creditInvestigation, setCreditInvestigation] = useState('')
  const creditInvestigationOnChange = (obj: OptionType) => {
    setCreditInvestigation(obj.value)
    if (obj.value) {
      setTimeout(() => {
        if (step < 9) {
          setStep(9)
        }
        if (!haveCityData) {
          // 显示地理位置权限确认弹窗
          openLocation()
        }
      }, 400)
    }
  }


  // 社保
  const [socialSecurity, setSocialSecurity] = useState('')
  const socialSecurityOnChange = (obj: OptionType) => {
    setSocialSecurity(obj.value)
    if (obj.value) {
      setTimeout(() => {
        if (step < 4) {
          setStep(4)
        }
      }, 400)
    }
  }

  // 公积金
  const [housingFund, setAccumulationFund] = useState('')
  const accumulationFundOnChange = (obj: OptionType) => {
    setAccumulationFund(obj.value)
    if (obj.value) {
      setTimeout(() => {
        if (step < 5) {
          setStep(5)
        }
      }, 400)
    }
  }

  // 保险保单
  const [insurance, setInsurancePolicy] = useState('')
  const insurancePolicyOnChange = (obj: OptionType) => {
    setInsurancePolicy(obj.value)
    if (obj.value) {
      setTimeout(() => {
        if (step < 6) {
          setStep(6)
        }
      }, 400)
    }
  }

  // 车产类型
  const [carProperty, setCarProduction] = useState('')
  const carProductionOnChange = (obj: OptionType) => {
    setCarProduction(obj.value)
    if (obj.value) {
      setTimeout(() => {
        if (step < 7) {
          setStep(7)
        }
      }, 400)
    }
  }

  // 房产类型
  const [houseProperty, setRealEstate] = useState('')
  const realEstateOnChange = (obj: OptionType) => {
    setRealEstate(obj.value)
    if (obj.value) {
      setTimeout(() => {
        if (step < 8) {
          setStep(8)
        }
      }, 400)
    }
  }

  interface assetInformationObjType {
    name: string,
    have: string,
    key: 'creditInvestigation' | 'payoffForm'
    options: OptionType[]
  }

  // const assetInformationObj = [
  //   {
  //     name: '信用情况',
  //     have: creditInvestigation,
  //     key: 'creditInvestigation',
  //     options: creditOptions
  //   },
  //   {
  //     name: '工资发放方式',
  //     have: payoffForm,
  //     key: 'payoffForm',
  //     options: payoffFormOptions
  //   }
  // ] as assetInformationObjType[]

  // 向下滚动
  const scrollDown = (distance = 250) => {
    const dom = document.getElementById('app')
    if (dom) {
      const currentScroll = dom.scrollTop || 0 // 已经被卷掉的高度
      setTimeout(() => {
        dom.scrollTo(0, currentScroll + distance)
      }, 0)
    }
  }

  // 回填数据

  const fillData = (info: any) => {
    // 先收集所有需要标记为完成的表单项
    const completedKeys: string[] = []

    // // 基于已填写信息推导应当所在步骤
    // const computeStepFromInfo = (detail: any) => {
    //   let nextStep = 1
    //   if (detail.job !== null && detail.job !== undefined) {
    //     nextStep = 2
    //   }
    //   if (detail.socialSecurity !== null && detail.socialSecurity !== undefined) {
    //     nextStep = Math.max(nextStep, 3)
    //   }
    //   if (detail.housingFund !== null && detail.housingFund !== undefined) {
    //     nextStep = Math.max(nextStep, 4)
    //   }
    //   if (detail.carProperty !== null && detail.carProperty !== undefined) {
    //     nextStep = Math.max(nextStep, 5)
    //   }
    //   if (detail.houseProperty !== null && detail.houseProperty !== undefined) {
    //     nextStep = Math.max(nextStep, 6)
    //   }
    //   if (detail.creditInvestigation !== null && detail.creditInvestigation !== undefined) {
    //     nextStep = Math.max(nextStep, 7)
    //   }
    //   if (from !== 'youxin' && detail.sesameCredit !== null && detail.sesameCredit !== undefined) {
    //     nextStep = Math.max(nextStep, 8)
    //   }
    //   if ((detail.workCity && detail.workCityCode) || detail.workCityCode) {
    //     nextStep = Math.max(nextStep, 9)
    //   }
    //   return nextStep
    // }

    // 回显除了最后一步的其它表单数据
    const tempFormItemList = formItemList.map((item, index) => {
      // if (item.key !== 'lastPage') {
      if ((info[item.key] === null || info[item.key] === undefined)) {
        setStep(index)
      } else {
        item.value = info[item.key] !== null ? info[item.key].toString() : null
      }
      // }
      return item
    })

    setFormItemList([...tempFormItemList])

    // 申请额度
    if (info.applyLimit !== null) {
      setApplyCredit(info.applyLimit.toString())
      completedKeys.push('applyLimit')
    }

    // 工作城市
    if (info.workCityCode || info.workCity) {
      setHaveCityData(true)
      setCityValue(info.workCityCode.split(','))
      setCityShow(info.workCity)
      completedKeys.push('workCity')
    }

    // 真实姓名
    if (info.realName !== null) {
      setRealName(info.realName)
    }
    // 身份证号
    if (info.identity !== null) {
      setIdentity(info.identity)
    }
    // 年龄
    if (info.age !== null) {
      setAge(info.age)
    }

    //有房产
    if (info.houseProperty !== null) {
      setRealEstate(info.houseProperty.toString())
      completedKeys.push('houseProperty')
    }
    // 车产
    if (info.carProperty !== null) {
      setCarProduction(info.carProperty.toString())
      completedKeys.push('carProperty')
    }
    //有社保
    if (info.socialSecurity !== null) {
      setSocialSecurity(info.socialSecurity.toString())
      completedKeys.push('socialSecurity')
    }
    // 有公积金
    if (info.housingFund !== null) {
      setAccumulationFund(info.housingFund.toString())
      completedKeys.push('housingFund')
    }

    // 是否逾期
    if (info.creditInvestigation !== null) {
      setCreditInvestigation(info.creditInvestigation.toString())
      completedKeys.push('creditInvestigation')
    }

    // 保险保单
    if (info.insurance !== null) {
      setInsurancePolicy(info.insurance.toString())
      completedKeys.push('insurance')
    }

    // 赋值给表单
    form.setFieldsValue({
      realName: info.realName,
      identity: info.identity,
      age: info.age,
      gender: info.gender
    })

    // 性别
    if (info.gender !== null) {
      setGender(info.gender)
    }

    // 职业类型
    if (info.job !== null) {
      setJob(info.job.toString())
      completedKeys.push('job')
    }

    // 工作年限
    if (showWorkDuration && info.workDuration !== null) {
      setWorkDuration(info.workDuration.toString())
    }
    // 月收入
    if (showMonthlyProfit && info.monthlyProfit !== null) {
      setMonthlyProfit(info.monthlyProfit.toString())
    }

    // 工资发放方式
    // if (info.payoffForm !== null) {
    //   setPayoffForm(info.payoffForm.toString())
    // }
    // 芝麻分
    if (info.sesameCredit !== null) {
      setCreditSesame(info.sesameCredit.toString())
      completedKeys.push('sesameCredit')
    }
    // 信用情况
    if (info.creditInvestigation !== null) {
      setCreditInvestigation(info.creditInvestigation.toString())
      completedKeys.push('creditInvestigation')
    }

    // 如果 formItemList 已经初始化，则更新表单项列表和完成状态
    if (formItemList.length > 0) {
      // 更新表单项列表和完成状态
      setFormItemList(prev => {
        const updatedList = prev.map(item => {
          // if (item.key !== 'lastPage') {
          const hasValue = info[item.key] !== null && info[item.key] !== undefined
          return {
            ...item,
            value: hasValue ? info[item.key].toString() : null
          }
          // }
          // return item
        })

        // 批量标记完成的表单项
        completedKeys.forEach(key => {
          const formIndex = updatedList.findIndex(item => item.key === key)
          if (formIndex !== -1) {
            setCompletedItems(prevState => {
              const newSet = new Set(prevState)
              newSet.add(formIndex)
              return newSet
            })
          }
        })

        return updatedList
      })

      // 数据回填后，先收起所有展开项，然后找到第一个没有数据的表单项并展开
      setTimeout(() => {
        // 先收起所有展开项
        setExpandedIndex(-1)
        // 然后找到第一个没有数据的表单项并展开
        findAndExpandFirstEmptyFormItem()
        // 确保所有已完成的表单项都可见
        const completedCount = completedKeys.length
        if (completedCount > 0) {
          setVisibleFormCount(Math.max(visibleFormCount, completedCount))
        }
        // 更新额度
        setEstimatedAmount(calculateTotalAmount())
        // 基础进度55%（申请额度已完成），每完成一项增加5%
        const progress = Math.min(55 + (completedCount * 5), 100)
        setProgressPercentage(progress)
        // 根据回填信息重置当前步骤
        // const inferredStep = computeStepFromInfo(info)
        // setStep(inferredStep)
      }, 100)
    }
  }

  const getFillData = () => {
    const params: any = {
      realName, // 真实姓名
      workCityCode: cityValue.join(), // 城市
      workCity: cityShow, // 城市
      // sesameCredit, // 芝麻分
      job, // 职业类型
      payoffForm, // 工资发放方式
      applyLimit, // 申请额度

      houseProperty, //房产
      carProperty, //车产
      socialSecurity, //社保
      housingFund, //公积金
      insurance, //保险保单
      creditInvestigation, // 信用情况
    }
    if (from !== 'youxin') {
      // 芝麻分
      params.sesameCredit = sesameCredit
    }
    if (showWorkDuration) {
      // 工作年限
      params.workDuration = workDuration
    }
    if (showMonthlyProfit) {
      // 月收入
      params.monthlyProfit = monthlyProfit
    }
    if (versionType === 'V2') {
      params.age = age
      params.gender = gender
    } else {
      params.identity = identity //身份证号
      if (validateIDNumber(identity)) {
        params.gender = getSex(identity) // 性别
        params.age = getAge(identity) // 年龄
      }
    }
    return params
  }

  // 保存上传
  const save = async(params: any) => {
    localStorage.setItem('fillInformation', JSON.stringify(params))
    try {
      await indexApi.tempSave(params)
    } catch (err) {
      console.log(err)
    }
  }
  // 对表单保存进行截流
  const debounceSave = useMemo(() => debounce(save, 2000, false), [])

  const handleLoginSuccess = (res: any) => {
    Storage.set(TOKEN, res.token)
    setToken(res.token)
  }

  // 将身份证输入单独拎出来监控
  useEffect(() => {
    if (identity) {
      if (validateIDNumber(identity)) {
        debounceSave(getFillData())
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [identity])

  // 表单各项变化监控(身份证除外)
  useEffect(() => {
    if (realName || age || gender || cityShow || sesameCredit || creditInvestigation || applyLimit || houseProperty || carProperty || socialSecurity
      || housingFund || insurance || job || workDuration || monthlyProfit || payoffForm) {
      debounceSave(getFillData())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    realName,
    age,
    gender,
    cityShow,
    sesameCredit,
    creditInvestigation,
    applyLimit,
    houseProperty,
    carProperty,
    socialSecurity,
    housingFund,
    insurance,
    job,
    workDuration,
    monthlyProfit,
    payoffForm
  ])

  const handleScrollTop = () => {
    const dom = document.getElementById('app')
    if (dom) {
      dom.scrollTo(0, 0)
    }
  }

  // 提交
  // 提交
  const confirm = (payload?: { realName?: string; identity?: string }) => {
    if (isFirstSubmit) {
      indexApi.reportUserBehavior(2)
      setIsFirstSubmit(false)
    }
    // if (!realName) {
    //   handleScrollTop()
    //   return Toast.show('请输入真实姓名')
    // }

    // if (!/^[\u4e00-\u9fa5]+$/.test(realName)) {
    //   return Toast.show('真实姓名不能含有非中文字符')
    // }

    // if (versionType === 'V2') {
    //   if (!age) {
    //     handleScrollTop()
    //     return Toast.show('请输入年龄')
    //   }
    //   if (!gender) {
    //     handleScrollTop()
    //     return Toast.show('请选择性别')
    //   }
    // }
    const effectiveRealName = payload?.realName ?? realName
    const effectiveIdentity = payload?.identity ?? identity

    if (!effectiveRealName) {
      return Toast.show('请输入真实姓名')
    }

    if (!/^[\u4e00-\u9fa5]+$/.test(effectiveRealName)) {
      return Toast.show('真实姓名不能含有非中文字符')
    }

    form.validateFields().then(obj => {
      if (!applyLimit) {
        return Toast.show('请选择申请额度')
      }

      if (!job) {
        return Toast.show('请选择职业类型')
      }

      if (!socialSecurity) {
        return Toast.show('请选择社保')
      }

      if (!housingFund) {
        return Toast.show('请选择公积金')
      }

      if (!insurance) {
        return Toast.show('请选择保险保单信息')
      }

      if (!carProperty) {
        return Toast.show('请选择车产')
      }

      if (!houseProperty) {
        return Toast.show('请选择房产')
      }

      if (!workDuration && showWorkDuration) {
        return Toast.show('请选择工作年限')
      }

      if (!monthlyProfit && showMonthlyProfit) {
        return Toast.show('请选择月收入')
      }

      if (!sesameCredit && from !== 'youxin') {
        return Toast.show('请选择芝麻分')
      }

      if (!creditInvestigation) {
        return Toast.show('请选择信用情况')
      }

      // if (!payoffForm) {
      //   return Toast.show('请选择工资发放方式')
      // }

      const params: any = {
        realName: effectiveRealName, // 真实姓名
        workCityCode: cityValue.join(), // 城市
        workCity: cityShow, // 城市
        job, // 职业类型
        payoffForm: '2', // 工资发放方式
        applyLimit, // 申请额度
        adChannelCode,
        isHuaWeiPhone,
        houseProperty, //房产
        carProperty, //车产
        socialSecurity, //社保
        housingFund, //公积金
        insurance, //保险保单
        creditInvestigation // 信用情况
      }
      if (versionType === 'V2') {
        if (age < 18) {
          return Toast.show('年龄需要大于18')
        }
        if (age > 99) {
          return Toast.show('年龄需要小于99')
        }
        params.age = age
        params.gender = gender
      } else {
        params.identity = effectiveIdentity //身份证号
        if (validateIDNumber(effectiveIdentity)) {
          params.gender = getSex(effectiveIdentity) // 性别
          params.age = getAge(effectiveIdentity) // 年龄
        }
      }

      if (from !== 'youxin') {
        // 芝麻分
        params.sesameCredit = sesameCredit
      }

      if (showWorkDuration) {
        // 工作年限
        params.workDuration = workDuration
      }

      if (showMonthlyProfit) {
        // 月收入
        params.monthlyProfit = monthlyProfit
      }

      localStorage.setItem('fillInformation', JSON.stringify(params))
      console.log(params)

      try {
        setBtnLoading(true)
        // 姓名、身份证二要素验证
        // await indexApi.identityNameVerify({ realName, identity, adChannelCode })

        // 显示动画并开始API请求

        // // 开始API请求
        // handleApiRequest(params)
        setTimeout(() => {
          setBtnLoading(false)
          window.location.href = `/fill-information/waiting-result?options=${encodeURIComponent(JSON.stringify(params))}&sourceType=submit`
        }, 100)

      } catch (error) {
        setBtnLoading(false)
      }
    })
      .catch(error => {
        // eslint-disable-next-line no-console
        // console.log('error', error)
        const dom = document.getElementById('app')
        if (dom) {
          dom.scrollTo(0, 0)
        }
      })
  }


  // const isHave = (key: assetInformationObjType['key'], have: number | string): void => {
  //   switch (key) {
  //     case 'creditInvestigation':
  //       creditConditionsOnChange(String(have))
  //       break
  //     case 'payoffForm':
  //       setPayoffForm(String(have))
  //       break
  //     default:
  //       break
  //   }
  // }

  // 新增：当前展开的表单项索引
  const [expandedIndex, setExpandedIndex] = useState<number>(0)
  // 新增：表单项是否已完成的标记
  const [completedItems, setCompletedItems] = useState<Set<number>>(new Set())
  // 新增：当前可见的表单项数量
  const [visibleFormCount, setVisibleFormCount] = useState<number>(1)

  // 抽取方法：标记表单项为已完成状态
  const markFormItemAsCompleted = (key: string, value: string) => {
    const formIndex = formItemList.findIndex(item => item.key === key)
    if (formIndex !== -1 && !completedItems.has(formIndex)) {
      setCompletedItems(prev => {
        const newSet = new Set(prev)
        newSet.add(formIndex)
        return newSet
      })

      // 更新表单项列表中的值
      setFormItemList(prev => prev.map((item, index) => {
        if (item.key === key) {
          return {
            ...item,
            value
          }
        }
        return item
      }))
    }
  }

  // 找到第一个没有数据的表单项并展开
  const findAndExpandFirstEmptyFormItem = () => {
    // 找到第一个没有值的表单项
    const firstEmptyIndex = formItemList.findIndex(item => !item.value)

    if (firstEmptyIndex !== -1) {
      // 展开第一个没有数据的表单项
      setExpandedIndex(firstEmptyIndex)
      // 确保该表单项可见
      setVisibleFormCount(Math.max(visibleFormCount, firstEmptyIndex + 1))
    } else {
      // 如果所有表单项都有数据，则收起所有展开项
      setExpandedIndex(-1)
      // 确保所有表单项都可见
      setVisibleFormCount(formItemList.length)
    }
  }


  const onChangeFormItem = (obj: OptionType, currentItem: any, nextIndex: any) => {
    // eslint-disable-next-line default-case
    switch (currentItem.key) {
      case 'applyLimit':
        applyCreditOnChange(obj)
        break
      case 'job':
        applyJobChange(obj)
        break
      case 'socialSecurity':
        socialSecurityOnChange(obj)
        break
      case 'housingFund':
        accumulationFundOnChange(obj)
        break
      case 'insurance':
        insurancePolicyOnChange(obj)
        break
      case 'carProperty':
        carProductionOnChange(obj)
        break
      case 'houseProperty':
        realEstateOnChange(obj)
        break
      case 'sesameCredit':
        creditSesameOnChange(obj)
        break
      case 'creditInvestigation':
        creditInvestigationOnChange(obj)
        break
      case 'workCity':
        // 城市选择不需要在这里处理，因为城市选择有特殊的渲染逻辑
        break
    }

    // 更新表单项的值
    const updatedFormItems = [...formItemList]
    updatedFormItems[nextIndex - 1].value = obj.value
    setFormItemList(updatedFormItems)

    // 标记当前项为已完成
    setCompletedItems(prev => new Set([...Array.from(prev), nextIndex - 1]))

    // 如果修改的是已完成的表单项，自动展开下一个没有数据的表单项
    if (nextIndex < updatedFormItems.length - 1) {
      // 仅在需要时增加可见数量，避免已全部可见时被收缩
      setVisibleFormCount(prev => Math.max(prev, nextIndex + 1))
      // 使用最新的表单项状态查找下一个空项
      const nextEmptyIndex = updatedFormItems.findIndex((item, index) => index >= nextIndex && !item.value)
      if (nextEmptyIndex !== -1) {
        setExpandedIndex(nextEmptyIndex)
      } else {
        // 如果后面所有表单项都有数据，则收起当前项
        setExpandedIndex(-1)
        // 确保所有表单项都可见
        setVisibleFormCount(updatedFormItems.length)
      }
    } else {
      // 如果是最后一个表单项，收起当前项
      setExpandedIndex(-1)
      // 确保所有表单项都可见
      setVisibleFormCount(updatedFormItems.length)
    }
    console.log('visibleFormCount', visibleFormCount)
  }


  useEffect(() => {
    // 如果是渠道特殊值有取消按钮，则在这里进行表单项的修改
    let items = [
      {
        name: '您想借多少？',
        key: 'applyLimit',
        value: '',
        options: channelValue?.includes('cancleFillBtn') ? applyCreditOptions.filter(item => item.value !== '1') : applyCreditOptions,
      },
      {
        name: '您的职业',
        key: 'job',
        value: '',
        options: jobTypeOptions,
      },
      {
        name: '本地社保缴纳',
        key: 'socialSecurity',
        value: '',
        options: socialSecurityOptions,
      },
      {
        name: '本地公积金缴纳',
        key: 'housingFund',
        value: '',
        options: accumulationFundOptions,
      },
      {
        name: '保险保单信息',
        key: 'insurance',
        value: '',
        options: insurancePolicyOptions,
      },
      {
        name: '是否有车',
        key: 'carProperty',
        value: '',
        options: carProductionOptions,
      },
      {
        name: '是否有房',
        key: 'houseProperty',
        value: '',
        options: realEstateOptions,
      },
      {
        name: '支付宝芝麻分',
        key: 'sesameCredit',
        value: '',
        options: creditSesameOptions,
      },
      {
        name: '是否逾期',
        key: 'creditInvestigation',
        value: '',
        options: creditOptions,
      },
      {
        name: '所在城市',
        key: 'workCity',
        value: '',
        options: [],
      },
      // {
      //   name: '',
      //   key: 'lastPage',
      //   value: '',
      //   options: [],
      // },
    ]
    setFormItemList(items)
  }, [channelValue])

  // 单页表单项列表
  const [formItemList, setFormItemList] = useState<FormDataItem[]>([])

  // const formItems = formItemList.map((formItem, formIndex) => (
  //   <Swiper.Item key={formIndex}>
  //     {
  //       formItem.key === 'lastPage' ? <>
  //         <div className={styles.lastBox}>
  //           <Form
  //             form={form}
  //             layout="horizontal"
  //             mode="card"
  //           >
  //             <div className={styles.lastBoxItem}>
  //               <div className={styles.formHeader}>
  //                 <img className={styles.formHeaderIcon} src={require('@imgs/information/safe-auth.png')} />
  //                 <div className={styles.formHeaderRight}>
  //                   <div className={styles.formHeaderTitle}>官方认证，保护您的隐私安全</div>
  //                   <div className={styles.formHeaderSubTitle}>您的身份证号码仅作真实性验证，我方不会另作他用</div>
  //                 </div>
  //               </div>
  //               <div className={styles.formBox}>
  //                 <Form.Item
  //                   label="真实姓名"
  //                   name="realName"
  //                   rules={[
  //                     {
  //                       validateTrigger: 'onblur',
  //                       required: true
  //                     },
  //                   ]}
  //                 >
  //                   <Input maxLength={4} value={realName} placeholder="请输入真实姓名" onBlur={val => {
  //                     setRealName(val.target.value)
  //                   }} />
  //                 </Form.Item>
  //                 <div className={styles.line}></div>
  //                 <Form.Item
  //                   label="身份证号"
  //                   name="identity"
  //                   rules={[
  //                     {
  //                       validateTrigger: 'onBlur',
  //                       validator: checkIdentity
  //                     }
  //                   ]}
  //                 >
  //                   <Input
  //                     placeholder="请输入身份证号"
  //                     maxLength={18}
  //                     value={identity}
  //                     onBlur={val => {
  //                       setIdentity(val.target.value)
  //                     }} />
  //                 </Form.Item>
  //               </div>
  //             </div>
  //             <div className={styles.lastBoxItem}>
  //               <div className={styles.formHeader}>
  //                 <img className={styles.formHeaderIcon} src={require('@imgs/information/address.png')} />
  //                 <div className={styles.formHeaderRight}>
  //                   <div className={styles.formHeaderTitle}>当前所在地址</div>
  //                   <div className={styles.formHeaderSubTitle}>请选择当前您所在的城市，提高匹配效率</div>
  //                 </div>
  //               </div>
  //               <div className={styles.formBox}>
  //                 <Form.Item
  //                   label="当前所在城市"
  //                   name="livingCity"
  //                   trigger="onConfirm"
  //                   className={styles.city}
  //                   rules={[
  //                     {
  //                       validator: checkLivingCity
  //                     }
  //                   ]}
  //                   onClick={e => {
  //                     setCityVisible(true)
  //                   }}>
  //                   <>
  //                     <div className={styles.row} >
  //                       <Input placeholder="请选择城市" readOnly value={cityShow} />
  //                     </div>
  //                     <CascadePicker
  //                       options={cityDate}
  //                       visible={cityVisible}
  //                       onClose={() => {
  //                         setCityVisible(false)
  //                       }}
  //                       value={cityValue}
  //                       onConfirm={cityConfirm}
  //                     />
  //                   </>
  //                 </Form.Item>
  //               </div>
  //             </div>

  //             <div className={styles.lastBoxItem}>
  //               <div className={styles.formHeader}>
  //                 <img className={styles.formHeaderIcon} src={require('@imgs/information/note.png')} />
  //                 <div className={styles.formHeaderRight}>
  //                   <div className={styles.formHeaderTitle}>您的逾期情况</div>
  //                   <div className={styles.formHeaderSubTitle}>逾期情况只作为您的资方匹配，请您认真选择</div>
  //                 </div>
  //               </div>
  //               <div className={styles.formBox}>
  //                 <div className={styles.content}>
  //                   {
  //                     assetInformationObj.map(item => {
  //                       return (
  //                         <div className={classNames([styles.selectBox, styles[item.key]])} key={item.key}>
  //                           <div className={styles.left}>{item.name}</div>
  //                           <div className={styles.right}>
  //                             {item.options.map(option => (
  //                               <span key={option.label} className={classNames(item.have === option.value && styles.active)} onClick={() => isHave(item.key, option.value)}>{option.label}</span>
  //                             ))}
  //                           </div>
  //                         </div>
  //                       )
  //                     })
  //                   }
  //                 </div>
  //                 {
  //                   showWorkDuration && <div className={styles.content}>
  //                     <ChooseOption
  //                       name="工作年限"
  //                       onChange={applyWorkDurationOnChange}
  //                       options={workDurationOptions}
  //                       initIsExpansion={initIsExpansion}
  //                       firstShowBottom={true}
  //                       value={workDuration}
  //                     />
  //                   </div>
  //                 }
  //                 {
  //                   showMonthlyProfit && <div className={styles.content}>
  //                     <ChooseOption
  //                       name="月收入"
  //                       onChange={applymonthlyProfitOnChange}
  //                       options={monthlyProfitOptions}
  //                       initIsExpansion={initIsExpansion}
  //                       firstShowBottom={true}
  //                       value={monthlyProfit}
  //                     />
  //                   </div>
  //                 }
  //                 {/* <div className={styles.content}>
  //                   <ChooseOption
  //                     name="工资发放方式"
  //                     onChange={applypayoffFormOnChange}
  //                     options={payoffFormOptions}
  //                     initIsExpansion={initIsExpansion}
  //                     firstShowBottom={true}
  //                     value={payoffForm}
  //                   />
  //                 </div> */}
  //               </div>
  //             </div>
  //           </Form>
  //           <Button block loading={btnLoading} loadingText="机构匹配中" className={styles.btn} shape="rounded" color="primary" onClick={confirm}>
  //             提交借款
  //           </Button>
  //         </div>
  //       </> : <>
  //         <FormChooseItem
  //           name={formItem.name}
  //           onChange={obj => onChangeFormItem(obj, formItem, formIndex + 1)}
  //           options={formItem.options}
  //           initIsExpansion={initIsExpansion}
  //           value={formItem.value}
  //         />
  //       </>
  //     }
  //   </Swiper.Item>
  // ))

  const onChangeSwiper = (index: number) => {
    // 当前下标 index
    setStep(index + 1)
  }

  // 计算额度增加量的函数
  const calculateAmountIncrease = (stepNumber: number, value: string) => {
    switch (stepNumber) {
      case 2: // 职业类型
        if (value === '10') {
          return 20000 // 上班族
        }
        if (value === '30') {
          return 50000 // 企业主
        }
        if (value === '20') {
          return 10000 // 自由职业
        }
        return 0
      case 3: // 社保
        if (value === '2') {
          return 10000 // 6个月以上
        }
        if (value === '1') {
          return 8000 // 6个月以下
        }
        if (value === '0') {
          return 2000 // 无社保
        }
        return 0
      case 4: // 公积金
        if (value === '2') {
          return 10000 // 6个月以上
        }
        if (value === '1') {
          return 8000 // 6个月以下
        }
        if (value === '0') {
          return 2000 // 无公积金
        }
        return 0
      case 5: // 保险保单
        if (value === '2') {
          return 10000 // 缴纳1年以上
        }
        if (value === '1') {
          return 8000 // 缴纳未满1年
        }
        if (value === '0') {
          return 2000 // 无保险
        }
        return 0
      case 6: // 车产
        if (value === '2') {
          return 20000 // 有且接受抵押
        }
        if (value === '1') {
          return 15000 // 有
        }
        if (value === '0') {
          return 2000 // 无车
        }
        return 0
      case 7: // 房产
        if (value === '2') {
          return 20000 // 有且接受抵押
        }
        if (value === '1') {
          return 18000 // 有
        }
        if (value === '0') {
          return 2000 // 无房
        }
        return 0
      case 8: // 芝麻分
        if (value === '3') {
          return 10000 // 700分以上
        }
        if (value === '2') {
          return 8000 // 650-700分
        }
        if (value === '5') {
          return 5000 // 600-650分
        }
        if (value === '4') {
          return 2000 // 600分以下
        }
        return 0
      case 9: // 信用情况
        if (value === '0') {
          return 10000 // 无逾期
        }
        if (value === '1') {
          return 2000 // 当前有逾期
        }
        return 0
      case 10: // 当前所在城市
        return 10000
      default:
        return 0
    }
  }

  // 计算总额度
  const calculateTotalAmount = () => {
    let totalAmount = 50000 // 基础额度

    // 根据各步骤的选择计算额度
    if (job) {
      totalAmount += calculateAmountIncrease(2, job)
    }
    if (socialSecurity) {
      totalAmount += calculateAmountIncrease(3, socialSecurity)
    }
    if (housingFund) {
      totalAmount += calculateAmountIncrease(4, housingFund)
    }
    if (insurance) {
      totalAmount += calculateAmountIncrease(5, insurance)
    }
    if (carProperty) {
      totalAmount += calculateAmountIncrease(6, carProperty)
    }
    if (houseProperty) {
      totalAmount += calculateAmountIncrease(7, houseProperty)
    }
    if (sesameCredit) {
      totalAmount += calculateAmountIncrease(8, sesameCredit)
    }
    if (creditInvestigation) {
      totalAmount += calculateAmountIncrease(9, creditInvestigation)
    }
    if (cityShow) {
      totalAmount += 10000
    }
    return totalAmount
  }

  // 计算已完成的项目数量
  const getCompletedItemsCount = () => {
    let count = 0
    if (applyLimit) {
      count++
    }
    if (job) {
      count++
    }
    if (socialSecurity) {
      count++
    }
    if (housingFund) {
      count++
    }
    if (insurance) {
      count++
    }
    if (carProperty) {
      count++
    }
    if (houseProperty) {
      count++
    }
    if (sesameCredit) {
      count++
    }
    if (creditInvestigation) {
      count++
    }
    // 添加了城市选择的检查
    if (cityShow) {
      count++
    }
    return count
  }

  // 设置进度和额度
  useEffect(() => {
    const completedCount = getCompletedItemsCount()
    console.log('completedCount', completedCount)
    // 基础进度20%（申请额度已完成），每完成一项增加10%
    const progress = Math.min(55 + (completedCount * 5), 100)
    setProgressPercentage(progress)

    // 更新额度
    setEstimatedAmount(calculateTotalAmount())

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applyLimit, job, socialSecurity, housingFund, insurance, carProperty, houseProperty, sesameCredit, creditInvestigation, cityShow])

  // 初始化进度
  useEffect(() => {
    setProgressPercentage(55)
    setEstimatedAmount(50000)
  }, [])

  // 获取定位
  const openLocation = () => {
    let isHandleCopyFunction = true
    let hasHandleCopyFunction = false
    // 开始执行位置授权
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          isHandleCopyFunction = false
          // 获取到的地理位置 position
          if (hasHandleCopyFunction) {
            return
          }
          getUserLocation(position.coords.latitude, position.coords.longitude)
        },
        error => {
          isHandleCopyFunction = false
          if (hasHandleCopyFunction) {
            return
          }
          getUserLocation(null, null)
        },
      )
    } else {
      getUserLocation(null, null)
    }
  }
  const getUserLocation = async(latitude: any, longitude: any) => {
    let params = latitude ? {
      location: `${latitude},${longitude}`,
      adChannelCode,
      coordtype: 'wgs84ll'
    } : {
      adChannelCode,
    }
    let res: any = await activityApi.reverseGeo(params)
    console.log(res)
    // res数据格式 例：{ province: 'xx', city: 'xx' }
    let currentProvince: any = cityDate.find(item => {
      return item.label === res.data?.province
    })
    let currentCity: any = ''
    if (currentProvince && currentProvince.children) {
      currentCity = currentProvince.children.find((cityItem: any) => {
        return cityItem.label === res.data?.city
      })
    }
    // 筛选出来的城市 currentProvince, currentCity
    if (currentProvince && currentCity && !haveCityData) {
      const workCityCode: any = `${currentProvince.value},${currentCity.value}`
      const workCity: any = `${currentProvince.label},${currentCity.label}`
      setCityValue(workCityCode.split(','))
      setCityShow(workCity)
      setHaveCityData(true)
      // 标记城市选择为已完成状态
      markFormItemAsCompleted('workCity', workCity)
      // 更新额度
      setEstimatedAmount(calculateTotalAmount())
    }
  }

  useEffect(() => {
    localStorage.removeItem('productBack')
  }, [])

  // 监听可见表单项数量变化，自动展开新显示的表单项
  useEffect(() => {
    if (visibleFormCount > 0) {
      setExpandedIndex(visibleFormCount - 1)
    }
  }, [visibleFormCount])

  return (
    <div className={styles.fillInformation} style={{ paddingTop: visibleHead ? 'auto' : '0px' }}>
      {
        visibleHead ? (<Header backCallBack={back} />) : (<></>)
      }

      <div className={styles.headerBox}>
        <div className={styles.headerContent}>
          <div className={styles.leftSection}>
            <div className={styles.estimatedText}>预估可借额度</div>
            <div className={styles.estimatedAmount}><span className={styles.estimatedUnit}>¥</span>{getCompletedItemsCount() === 0 ? '*****' : displayAmount.toLocaleString()}</div>
            <div className={styles.instructionText}>请准确填写本人信息，否则申请失败~</div>
          </div>
          <div className={styles.rightSection}>
            <div className={styles.progressContainer}>
              <div className={styles.progressBar}>
                <div
                  className={styles.progressFill}
                  style={{ width: `${progressPercentage}%` }}
                >
                  <div className={styles.progressStripes}></div>
                </div>
                <div
                  className={styles.progressLabel}
                  style={{ right: `${100 - progressPercentage}%` }}
                >
                  进度{progressPercentage}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.formContainer}>
        {/* 基本信息卡片 */}
        <div className={styles.formCard}>
          <div className={styles.formCardHeader}>
            <div className={styles.formCardTitle}>
              <img className={styles.formCardIcon} src={require('@imgs/information/ic-basic.png')} />
              <span>基本信息  {Math.min(Array.from(completedItems).filter(index => index < 9).length, 9)}/9</span>
            </div>
          </div>

          {/* 基本信息表单项 */}
          {formItemList.slice(0, Math.min(visibleFormCount, 9)).map((formItem, formIndex) => (
            <div key={formIndex} className={classNames(styles.formItem, {
              [styles.expanded]: expandedIndex === formIndex,
              [styles.completed]: completedItems.has(formIndex)
            })}>
              <div className={styles.formItemHeader} onClick={() => {
                if (expandedIndex === formIndex) {
                  // 如果当前项已经展开，则收起
                  setExpandedIndex(-1)
                } else {
                  // 否则展开当前项
                  setExpandedIndex(formIndex)
                }
              }}>
                <div className={styles.formItemTitle}>
                  <span>{formItem.name}</span>
                </div>
                <div className={styles.formItemStatus}>
                  {completedItems.has(formIndex) ? (
                    <span className={styles.completedText}>
                      {formItem.key === 'workCity'
                        ? cityShow
                        : formItem.options.find(opt => opt.value === formItem.value)?.label || formItem.value
                      }
                      {expandedIndex === formIndex ? <img className={styles.upIcon} src={iconUp} /> : <img className={styles.rightIcon} src={iconRight} />}
                    </span>
                  ) : (
                    <span className={styles.uncompletedText}>
                      请选择
                      {expandedIndex === formIndex ? <img className={styles.upIcon} src={iconUp} /> : <img className={styles.rightIcon} src={iconRight} />}
                    </span>
                  )}
                </div>
              </div>
              {expandedIndex === formIndex && (
                <div className={styles.formItemContent}>
                  <FormChooseItem
                    name={formItem.name}
                    onChange={obj => onChangeFormItem(obj, formItem, formIndex + 1)}
                    options={formItem.options}
                    initIsExpansion={true}
                    value={formItem.value}
                  />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* 其他信息卡片 - 只有当基本信息都完成时才显示 */}
        {Array.from(completedItems).filter(index => index < 9).length >= 9 && (
          <>
            <div className={styles.formCard}>
              <div className={styles.formCardHeader}>
                <div className={styles.formCardTitle}>
                  <img className={styles.formCardIcon} src={require('@imgs/information/ic-basic.png')} />
                  <span>其他信息  {Math.max(0, Math.min(Array.from(completedItems).filter(index => index >= 9).length, 1))}/1</span>
                </div>
              </div>

              {/* 其他信息表单项 */}
              {formItemList.slice(9, visibleFormCount).map((formItem, formIndex) => {
                const actualIndex = formIndex + 9
                return (
                  <div key={actualIndex} className={classNames(styles.formItem, {
                    [styles.expanded]: expandedIndex === actualIndex,
                    [styles.completed]: completedItems.has(actualIndex)
                  })}>
                    <div className={styles.formItemHeader} onClick={() => {
                      setExpandedIndex(actualIndex)
                      setCityVisible(true)
                    }}>
                      <div className={styles.formItemTitle}>
                        <span>{formItem.name}</span>
                      </div>
                      <div className={styles.formItemStatus}>
                        {completedItems.has(actualIndex) ? (
                          <span className={styles.completedText}>
                            {formItem.key === 'workCity' ? cityShow : (formItem.options.find(opt => opt.value === formItem.value)?.label || '已完成')}
                            <img className={styles.rightIcon} src={iconRight} />
                          </span>
                        ) : (
                          <span className={styles.uncompletedText} onClick={() => {
                            setExpandedIndex(actualIndex)
                            setCityVisible(true)
                          }}>
                            请选择工作城市
                            <img className={styles.rightIcon} src={iconRight} />
                          </span>
                        )}
                      </div>
                    </div>
                    {expandedIndex === actualIndex && (
                      <div className={styles.formItemContent}>
                        {formItem.key === 'workCity' ? (
                          // 城市选择特殊渲染
                          <div className={styles.citySelection}>
                            <div className={styles.city}>
                              <CascadePicker
                                options={cityDate}
                                visible={cityVisible}
                                onClose={() => setCityVisible(false)}
                                value={cityValue}
                                onConfirm={cityConfirm}
                              />
                            </div>
                          </div>
                        ) : (
                          <FormChooseItem
                            name={formItem.name}
                            onChange={obj => onChangeFormItem(obj, formItem, actualIndex + 1)}
                            options={formItem.options}
                            initIsExpansion={true}
                            value={formItem.value}
                          />
                        )}
                      </div>
                    )}
                  </div>
                )
              })}
            </div>
            <Button
              block
              loading={btnLoading}
              loadingText="机构匹配中"
              className={classNames(styles.btn)}
              shape="rounded"
              color="primary"
              onClick={() => setIdentityInfoModalVisible(true)}
              disabled={!(job && cityShow && houseProperty && carProperty && socialSecurity && housingFund && sesameCredit && creditInvestigation)}
            >
              提交获取额度
            </Button>
          </>
        )}
      </div>
      <div className={styles.btnTip}>
        <img
          src={require('@imgs/register/jufu/protect.png')}
          alt="保护"
          className={styles.protectIcon}
          style={{
            width: '11px',
            height: '12px',
            verticalAlign: 'middle',
            marginRight: '4px'
          }}
        />
        信息用于额度评估
      </div>

      {/* 身份信息弹窗 */}
      <IdentityInfoModal
        maxAmount={estimatedAmount}
        visible={identityInfoModalVisible}
        onClose={handleCloseIdentityInfoModal}
        onSubmit={handleIdentityInfoSubmit}
      />

      {/* 匹配动画组件 */}
      <MatchAnimate
        visible={showMatchAnimation}
        onAnimationComplete={handleMatchAnimationComplete}
        loop={true}
      />

    </div>
  )
}

export default FillInformation